// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pu-filter-selected-item-box[data-v-bd26ad50] {\n  color: var(--sea);\n  background-color: #edf5f4;\n  border-radius: 6px;\n  padding: 0.38rem 0.6rem;\n  font-weight: 400;\n  font-size: 0.9rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
